var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-auto-img"},[_c('img',{staticClass:"base-auto-img__img",style:({
      objectFit: _vm.fit,
    }),attrs:{"src":_vm.src},on:{"load":_vm.onLoad,"error":_vm.onError}}),(_vm.loading)?_c('div',{staticClass:"base-auto-img__loading"},[_vm._t("loading")],2):_vm._e(),(_vm.error)?_c('div',{staticClass:"base-auto-img__error"},[_vm._t("error")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }